export default __webpack_public_path__ + "static/media/GM.17036e1d.svg";